import { useMemo } from 'react'
import useDismissBanner from './useDismissBanner'
import { useUser } from '../context/User'

interface UseCoachMarkReturn {
  isCoachMarkActive: boolean
  onDismissCoachMark: () => void
}

const COACH_MARK_DAYS_DURATION = 14

export const useCoachMark = (args: {
  banner: string
  coachMarkReleaseDate: string
  hideForNewUsers?: boolean
}): UseCoachMarkReturn => {
  const { banner, coachMarkReleaseDate, hideForNewUsers = true } = args

  const { onDismissBanner, isActive: isBannerActive } = useDismissBanner({
    banner,
  })
  const { createdAt: signupDate } = useUser()

  const isCoachMarkActive = useMemo(() => {
    const coachMarkStartDate = new Date(coachMarkReleaseDate)
    const coachMarkEndDate = new Date(coachMarkReleaseDate)
    coachMarkEndDate.setDate(
      coachMarkEndDate.getDate() + COACH_MARK_DAYS_DURATION,
    )
    const currentDate = new Date()

    // Check if the current date is between the coach mark release date and the coach mark end date
    const isWithinCoachMarkPeriod =
      currentDate >= coachMarkStartDate && currentDate <= coachMarkEndDate

    // Check if the user is a new user and should be hidden from the coach mark
    const shouldHideFromUser =
      hideForNewUsers &&
      signupDate &&
      new Date(signupDate) >= coachMarkStartDate

    return isBannerActive && isWithinCoachMarkPeriod && !shouldHideFromUser
  }, [isBannerActive, coachMarkReleaseDate, hideForNewUsers, signupDate])

  return {
    isCoachMarkActive,
    onDismissCoachMark: onDismissBanner,
  }
}
